"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var MissingComponent_1 = require("../components/MissingComponent");
var utils_1 = require("../utils");
var PlaceholderCommon = /** @class */function (_super) {
  __extends(PlaceholderCommon, _super);
  function PlaceholderCommon(props) {
    var _this = _super.call(this, props) || this;
    _this.nodeRefs = [];
    _this.state = {};
    _this.addRef = _this.addRef.bind(_this);
    _this.updateKeyAttributes = _this.updateKeyAttributes.bind(_this);
    _this.createRawElement = _this.createRawElement.bind(_this);
    return _this;
  }
  PlaceholderCommon.getPlaceholderDataFromRenderingData = function (rendering, name) {
    var result;
    if (rendering && rendering.placeholders && Object.keys(rendering.placeholders).length > 0) {
      result = rendering.placeholders[name];
    } else {
      result = null;
    }
    if (!result) {
      console.warn("Placeholder '" + name + "' was not found in the current rendering data", JSON.stringify(rendering, null, 2));
      return [];
    }
    return result;
  };
  PlaceholderCommon.prototype.componentDidMount = function () {
    this.updateKeyAttributes();
  };
  PlaceholderCommon.prototype.componentDidUpdate = function () {
    this.updateKeyAttributes();
  };
  PlaceholderCommon.prototype.componentDidCatch = function (error) {
    this.setState({
      error: error
    });
  };
  PlaceholderCommon.prototype.getComponentsForRenderingData = function (placeholderData) {
    var _this = this;
    var _a = this.props,
      name = _a.name,
      placeholderFields = _a.fields,
      placeholderParams = _a.params,
      missingComponentComponent = _a.missingComponentComponent,
      placeholderProps = __rest(_a, ["name", "fields", "params", "missingComponentComponent"]);
    return placeholderData.map(function (rendering, index) {
      var key = rendering.uid ? rendering.uid : "component-" + index;
      var commonProps = {
        key: key
      };
      // if the element is not a 'component rendering', render it 'raw'
      if (!rendering.componentName && rendering.name) {
        return _this.createRawElement(rendering, commonProps);
      }
      var component = _this.getComponentForRendering(rendering);
      if (!component) {
        console.error("Placeholder " + name + " contains unknown component " + rendering.componentName + ". Ensure that a React component exists for it, and that it is registered in your componentFactory.js.");
        component = missingComponentComponent || MissingComponent_1.MissingComponent;
      }
      var finalProps = __assign(__assign(__assign(__assign(__assign({}, commonProps), placeholderProps), (placeholderFields || rendering.fields) && {
        fields: __assign(__assign({}, placeholderFields), rendering.fields)
      }), (placeholderParams || rendering.params) && {
        params: __assign(__assign({}, placeholderParams), rendering.params)
      }), {
        rendering: rendering
      });
      return react_1.default.createElement(component, finalProps);
    }).filter(function (element) {
      return element;
    }); // remove nulls
  };
  PlaceholderCommon.prototype.getComponentForRendering = function (renderingDefinition) {
    var componentFactory = this.props.componentFactory;
    if (!componentFactory || typeof componentFactory !== 'function') {
      console.warn("No componentFactory was available to service request for component " + renderingDefinition);
      return null;
    }
    return componentFactory(renderingDefinition.componentName);
  };
  PlaceholderCommon.prototype.addRef = function (nodeRef) {
    this.nodeRefs.push(nodeRef);
  };
  PlaceholderCommon.prototype.createRawElement = function (elem, baseProps) {
    if (!elem.name) {
      console.error('"elem.name" is undefined in "createRawElement". Something is likely wrong with your component data. Ensure that your components have a name.');
      return null;
    }
    var attributes = utils_1.convertAttributesToReactProps(elem.attributes);
    var props = __assign(__assign(__assign({}, baseProps), attributes), {
      dangerouslySetInnerHTML: {
        __html: elem.contents
      }
    });
    /* Since we can't set the "key" attribute via React, stash it
      * so we can set in the DOM after render.
      */
    if (attributes && attributes.chrometype === 'placeholder') {
      props.phkey = elem.attributes.key; // props that get rendered as dom attribute names need to be lowercase, otherwise React complains.
      props.ref = this.addRef; // only need ref for placeholder containers, trying to add it to other components (e.g. stateless components) may result in a warning.
    }
    return react_1.default.createElement(elem.name, props);
  };
  PlaceholderCommon.prototype.updateKeyAttributes = function () {
    if (!this.nodeRefs) {
      return;
    }
    this.nodeRefs.forEach(function (ref) {
      if (ref && ref.getAttribute) {
        // ref might be a wrapped component, so check for existence of getAttribute method
        var key = ref.getAttribute('phkey');
        if (key) {
          // need to manually set the 'key' attribute after component mount because
          // 'key' is a reserved attribute/prop in React. so it will never be rendered
          // as an html attribute.
          ref.setAttribute('key', key);
        }
      }
    });
  };
  PlaceholderCommon.propTypes = {
    rendering: prop_types_1.default.oneOfType([prop_types_1.default.object, prop_types_1.default.object]).isRequired,
    fields: prop_types_1.default.objectOf(prop_types_1.default.oneOfType([prop_types_1.default.object, prop_types_1.default.object]).isRequired),
    params: prop_types_1.default.objectOf(prop_types_1.default.string.isRequired),
    missingComponentComponent: prop_types_1.default.oneOfType([prop_types_1.default.object, prop_types_1.default.object]),
    errorComponent: prop_types_1.default.oneOfType([prop_types_1.default.object, prop_types_1.default.object])
  };
  return PlaceholderCommon;
}(react_1.default.Component);
exports.PlaceholderCommon = PlaceholderCommon;